import { call, put, all, fork, takeLatest, delay } from "redux-saga/effects";

import { FETCH_PROFILE, UPDATE_PROFILE } from "./actionTypes";
import { LOGIN_SUCCESS } from "../login/actionTypes";
import {
  receivedProfile,
  resetProfileStatus,
  logoutUser,
  updateProfileSuccess,
  updateProfileError,
} from "../../actions";

import { APIClient } from "../../../helpers/api_helper";
import { encryptData, decryptData } from "../../../helpers/crypto_utils";
import i18n from "../../../i18n";
import { translateApiError } from "../../../helpers/translateApiError";

const api = new APIClient();

function* fetchProfile() {
  try {
    // Delay to allow serverless Lambda to warm up after login
    yield delay(1500);

    // Use silent: true to suppress error toast for this background request
    const urlProfile = () =>
      api.get(`${process.env.REACT_APP_API_BASE_URL}/api/me`, null, { silent: true });
    const response = yield call(urlProfile);

    if (response.id !== undefined) {
      const userChannel = response?.channels.filter((channel) => {
        return channel.code !== "__default_channel__";
      });

      sessionStorage.setItem("hxsmsToken", `${userChannel[0]?.token}`);

      yield put(receivedProfile(response));
    } else {
      yield put(resetProfileStatus());

      if (response?.message === "DISABLED_COMPANY_ERROR") {
        window.location.href = `/403`;
        yield put(logoutUser());
      } else if (response?.message === "DELETED_COMPANY_ERROR") {
        window.location.href = `/404`;
        yield put(logoutUser());
      }
    }
  } catch (error) {
    console.error(error);
  }
}

export function* watchFetchCompany() {
  yield takeLatest([LOGIN_SUCCESS, FETCH_PROFILE], fetchProfile);
}

function* updateProfileSaga(action) {
  try {
    const response = yield call(() =>
      api.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/profile`,
        action.payload
      )
    );


    // After the axios interceptor parses the body, we get { status_code, message, data }
    if (response.status_code === 200 && response.data) {
      // Update the auth user storage with new profile data
      const authUserStorage =
        sessionStorage.getItem("authUser") || localStorage.getItem("authUser");
      if (authUserStorage) {
        // Decrypt the stored auth data first
        const authData = decryptData(authUserStorage);
        if (authData) {
          // Update the profile data - map camelCase to snake_case to match login format
          authData.userProfile = {
            ...authData.userProfile,
            email: response.data.email,
            first_name: response.data.firstName,
            lastName: response.data.lastName,
            firstName: response.data.firstName,
            last_name: response.data.lastName,
            profilePictureUrl: response.data.profilePictureUrl,
          };
          // Re-encrypt and store
          const storage = sessionStorage.getItem("authUser")
            ? sessionStorage
            : localStorage;
          storage.setItem("authUser", encryptData(authData));
        }
      }

      yield put(updateProfileSuccess(response.data));
    } else {
      yield put(
        updateProfileError(
          translateApiError(
            response.message,
            i18n.t("account.errors.updateFailed")
          )
        )
      );
    }
  } catch (error) {
    console.error("Error updating profile:", error);
    yield put(
      updateProfileError(
        translateApiError(error.message, i18n.t("account.errors.updateFailed"))
      )
    );
  }
}

export function* watchUpdateProfile() {
  yield takeLatest(UPDATE_PROFILE, updateProfileSaga);
}

function* ProfileSaga() {
  yield all([fork(watchFetchCompany), fork(watchUpdateProfile)]);
}

export default ProfileSaga;
